// Every server endpoint, for the website and the phone app. Each app
// passes its own API address (from its environment config).
export const buildApiRoutes = (apiBaseURL) => ({
  Act: apiBaseURL + '/artists/act/',
  ActCreate: apiBaseURL + '/artists/acts/',
  
  // Act Management API Routes
  ActsList: apiBaseURL + '/artists/acts/',
  ActsPublic: apiBaseURL + '/artists/acts/public/',
  CreatorActs: apiBaseURL + '/artists/acts/my/',
  ActDetail: apiBaseURL + '/artists/act/',
  PublicActDetail: apiBaseURL + '/artists/act/',
  ActDetailBySlug: apiBaseURL + '/artists/act/',
  ActMembers: apiBaseURL + '/artists/act/',
  ActVerificationRequest: apiBaseURL + '/artists/act/',
  ActStatistics: apiBaseURL + '/artists/act/',
  CreatorStatistics: apiBaseURL + '/artists/creator/statistics/',
  PodcasterStatistics: apiBaseURL + '/artists/podcaster/statistics/',
  PodcasterDrafts: apiBaseURL + '/music/podcaster/drafts/',
  PodcasterEarnings: apiBaseURL + '/artists/podcaster/earnings/',
  VerificationRequests: apiBaseURL + '/artists/verification-requests/',
  ActCreditBalance: apiBaseURL + '/artists/act/',
  ActBalance: (actId) => apiBaseURL + `/artists/act/${actId}/balance/`,
  ActEarningsTransactions: (actId) => apiBaseURL + `/artists/act/${actId}/balance/transactions/`,
  ActBankAccounts: (actId) => apiBaseURL + `/artists/act/${actId}/bank-accounts/`,
  ActAddBankAccount: (actId) => apiBaseURL + `/artists/act/${actId}/bank-accounts/add/`,
  ActSetPrimaryBankAccount: (actId, accountId) => apiBaseURL + `/artists/act/${actId}/bank-accounts/${accountId}/set-primary/`,
  ActDeleteBankAccount: (actId, accountId) => apiBaseURL + `/artists/act/${actId}/bank-accounts/${accountId}/delete/`,
  ActRequestPayout: (actId) => apiBaseURL + `/artists/act/${actId}/payout/request/`,
  ActPayouts: (actId) => apiBaseURL + `/artists/act/${actId}/payouts/`,
  
  Album: apiBaseURL + '/music/albums/',
  AlbumDetail: apiBaseURL + '/music/album/',
  AlbumTracks: apiBaseURL + '/music/album-tracks/',
  AlbumStatistics: apiBaseURL + '/music/album/',
  CreateAlbum: apiBaseURL + '/music/album/create/',
  Track: apiBaseURL + '/music/tracks/',
  SharedWithMe: apiBaseURL + '/music/shared-with-me/',
  TrackDetail: apiBaseURL + '/music/track/',
  TrackStatistics: apiBaseURL + '/music/track/',
  CreateTrack: apiBaseURL + '/music/track/create/',
  TemporaryUpload: apiBaseURL + '/music/temporary-upload/',
  Podcasts: apiBaseURL + '/music/podcasts/',
  PodcastDetail: (idOrSlug) => apiBaseURL + `/music/podcasts/${idOrSlug}/`,
  PodcastEpisodes: apiBaseURL + '/music/podcast-episodes/',
  PodcastEpisodeDetail: (id) => apiBaseURL + `/music/podcast-episodes/${id}/`,
  MusicConnections: apiBaseURL + '/music/connections',
  MusicInvitations: apiBaseURL + '/music/invitations',
  TrackConnections: apiBaseURL + '/music/track-connections/',
  AlbumConnections: apiBaseURL + '/music/album-connections/',
  AlbumInvitations: apiBaseURL + '/music/album-invitations/',
  
  // Credits Management API Routes
  AvailableRoles: apiBaseURL + '/music/roles/',
  SearchRoles: apiBaseURL + '/music/roles/search/',
  CreateCustomRole: apiBaseURL + '/music/roles/create/',
  Collaborators: apiBaseURL + '/music/collaborators/',
  CollaboratorsFindOrCreate: apiBaseURL + '/music/collaborators/find_or_create/',
  CollaboratorsSendInvitation: apiBaseURL + '/music/collaborators/',
  CollaboratorsSendBulkInvitations: apiBaseURL + '/music/collaborators/send_bulk_invitations/',
  CreateCollaboratorCredit: apiBaseURL + '/music/collaborators/create_credit/',
  BatchCreateCollaboratorCredits: apiBaseURL + '/music/collaborators/batch_create_credits/',
  DeleteCollaboratorCredit: (id) => apiBaseURL + `/music/collaborators/delete_credit/${id}/`,
  BatchDeleteCollaboratorCredits: apiBaseURL + '/music/collaborators/batch_delete_credits/',
  ResendCollaboratorInvitation: (creditId) => apiBaseURL + `/music/collaborators/resend_invitation/${creditId}/`,
  Credits: apiBaseURL + '/music/credits/',
  CreditDetail: (id) => apiBaseURL + `/music/credits/${id}/`,
  CollaboratorDetail: (id) => apiBaseURL + `/music/collaborators/${id}/`,
  TrackCredits: (trackId) => apiBaseURL + `/music/tracks/${trackId}/credits/`,
  AlbumCredits: (albumId) => apiBaseURL + `/music/albums/${albumId}/credits/`,
  
  // Songwriting Credits API Routes
  SongwritingCredits: apiBaseURL + '/music/songwriting-credits/',
  SongwritingCreditDetail: (id) => apiBaseURL + `/music/songwriting-credits/${id}/`,
  SearchCreatorsForCredits: apiBaseURL + '/music/creators/search-for-credits/',
  
  // Library API Routes
  Library: apiBaseURL + '/music/library/',
  LibraryToggle: apiBaseURL + '/music/library/toggle/',
  LibraryStatus: apiBaseURL + '/music/library/',

  // Like/Favorite API Routes
  LikeToggle: apiBaseURL + '/music/like/toggle/',
  UserLikes: apiBaseURL + '/music/likes/user/',
  PublicUserLikes: (uuid) => apiBaseURL + `/music/likes/user/${uuid}/`,
  ClaimReferral: apiBaseURL + '/music/referrals/claim/',
  // Keeping music on a device for offline listening (offlineRules.js)
  OfflineFile: (trackId) => apiBaseURL + `/music/track/${trackId}/offline-file/`,
  OfflineAllowance: apiBaseURL + '/music/offline-allowance/',
  OfflinePlays: apiBaseURL + '/music/offline-plays/',
  // What this listener has bought or downloaded (?page_size=)
  UserDownloads: apiBaseURL + '/music/downloads/user/',
  ContentLikes: apiBaseURL + '/music/likes/',
  ActLikes: apiBaseURL + '/music/likes/act/',
  CreatorLikes: apiBaseURL + '/music/likes/creator/',
  
  // Listener Curation Tracking API Routes
  GetCurationContext: apiBaseURL + '/music/curation/context/',
  ClearCurationContext: apiBaseURL + '/music/curation/context/clear/',
  
  // Playlist API Routes
  PlaylistCreate: apiBaseURL + '/music/playlist/create/',
  PlaylistDetail: apiBaseURL + '/music/playlist/',
  // Editing a playlist its curator manages
  UpdatePlaylist: (playlistId) => apiBaseURL + `/music/playlist/${playlistId}/update/`,
  ReorderPlaylist: (playlistId) => apiBaseURL + `/music/playlist/${playlistId}/reorder/`,
  AddPlaylistTrack: (playlistId) => apiBaseURL + `/music/playlist/${playlistId}/add-track/`,
  RemovePlaylistTrack: (playlistId, trackId) => apiBaseURL + `/music/playlist/${playlistId}/remove-track/${trackId}/`,
  PlaylistList: apiBaseURL + '/music/playlists/',
  UserPlaylists: apiBaseURL + '/music/playlists/my/',
  CurationLabels: apiBaseURL + '/artists/labels/curation-labels/',
  CreatorPlaylists: apiBaseURL + '/music/playlists/creator/',
  PlaylistListeningTime: apiBaseURL + '/music/playlist/',
  
  // Playlist Link Management API Routes
  UserAvailablePlaylists: apiBaseURL + '/music/playlist-links/available/',
  GetListenerPlaylists: apiBaseURL + '/music/playlist-links/listener-playlists/',
  CreatorLinkedPlaylists: apiBaseURL + '/music/playlist-links/creator/',
  ActLinkedPlaylists: apiBaseURL + '/music/playlist-links/act/',
  CreatePlaylistLink: apiBaseURL + '/music/playlist-links/create/',
  UpdatePlaylistLink: apiBaseURL + '/music/playlist-links/',
  DeletePlaylistLink: apiBaseURL + '/music/playlist-links/',
  AlbumListeningTime: apiBaseURL + '/music/album/',
  Login: apiBaseURL + '/auth/login/',
  ChangePassword: apiBaseURL + '/auth/change-password/',
  Register: apiBaseURL + '/auth/register/',
  SignupStatus: apiBaseURL + '/auth/signup-status/',
  CompleteSignup: apiBaseURL + '/auth/complete-signup/',
  ResumeSignup: apiBaseURL + '/auth/resume-signup/',
  EmailVerification: apiBaseURL + '/auth/verify-email/',
  ResendVerification: apiBaseURL + '/auth/resend-verification/',
  User: apiBaseURL + '/auth/user/',
  PublicUser: apiBaseURL + '/auth/user/',
  PublicUsers: apiBaseURL + '/auth/users/public/',
  MessagingUsers: apiBaseURL + '/auth/users/messaging/',
  PublicCreators: apiBaseURL + '/auth/creators/public/',
  PublicPodcasters: apiBaseURL + '/auth/podcasters/public/',
  ProfileUpdate: apiBaseURL + '/auth/profile-update/',
  ImageUpload: apiBaseURL + '/auth/image-upload/',
  DeleteAccount: apiBaseURL + '/auth/delete/',
  EmailPreferences: apiBaseURL + '/auth/email-preferences/',
  UserDataExport: apiBaseURL + '/auth/user/data-export/',
  UnsubscribeEmail: apiBaseURL + '/auth/email-preferences/unsubscribe/',
  
  // Payout and Payment API Routes
  UserEarnings: apiBaseURL + '/payouts/earnings/',
  EarningsTrends: apiBaseURL + '/payouts/earnings/trends/',
  TransactionEarnings: apiBaseURL + '/payouts/transactions/',
  ExportTransactionEarnings: apiBaseURL + '/payouts/transactions/export/',
  UserPayouts: apiBaseURL + '/payouts/history/',
  
  // Tax Reporting API Routes
  TaxSummary: apiBaseURL + '/tax/summary/',
  TaxReport: apiBaseURL + '/tax/report/',
  Tax1099: apiBaseURL + '/tax/1099/',
  
  // Podcast Streaming API Routes
  // A track's listening session: started before playback (refused with 402
  // without enough credit), ended with how long they listened, which is
  // what's charged
  StartListeningSession: apiBaseURL + '/music/track/listening/start/',
  EndListeningSession: (streamId) => apiBaseURL + `/music/track/listening/${streamId}/end/`,
  // Seconds listened so far, every half minute while playing
  ListeningProgress: (streamId) => apiBaseURL + `/music/track/listening/${streamId}/progress/`,
  // Where to stream a track from: comes with the session's start; this
  // gives it again within an open session, or to those who play it free
  TrackAudio: (trackId) => apiBaseURL + `/music/track/${trackId}/audio/`,
  StartPodcastListeningSession: apiBaseURL + '/music/podcast/episode/listening/start/',
  EndPodcastListeningSession: apiBaseURL + '/music/podcast/episode/listening/',
  
  RequestPayout: apiBaseURL + '/payouts/request/',
  PaymentMethods: apiBaseURL + '/payments/methods/',
  PaymentMethodDetail: apiBaseURL + '/payments/methods/',
  PaymentMethodSetPrimary: (id) => apiBaseURL + `/payments/methods/${id}/set-primary/`,
  PaymentMethodDelete: (id) => apiBaseURL + `/payments/methods/${id}/delete/`,
  AddPaymentMethod: apiBaseURL + '/payments/methods/add/',
  DepositTransactions: apiBaseURL + '/payments/transactions/',
  AutoDepositSettings: apiBaseURL + '/payments/auto-deposit-settings/',
  DepositTransactionCreate: apiBaseURL + '/payments/transactions/create/',
  ConfirmPayment: apiBaseURL + '/payments/confirm/',
  AddCredit: apiBaseURL + '/payments/add-credit/',
  UserCreditStatus: apiBaseURL + '/payments/credit-status/',
  
  // Act Revenue Split API Routes
  ActRevenueSplits: apiBaseURL + '/artists/act/',
  UpdateActRevenueSplits: apiBaseURL + '/artists/act/',
  AddActMemberSplit: apiBaseURL + '/artists/act/',
  RemoveActMemberSplit: apiBaseURL + '/artists/act/',
  
  // Bank Account API Routes
  BankAccounts: apiBaseURL + '/payouts/bank-accounts/',
  PayoutAccount: apiBaseURL + '/payouts/account/',
  SetUpPayoutAccount: apiBaseURL + '/payouts/account/set-up/',
  AddBankAccount: apiBaseURL + '/payouts/bank-accounts/add/',
  SetPrimaryBankAccount: apiBaseURL + '/payouts/bank-accounts/',
  DeleteBankAccount: apiBaseURL + '/payouts/bank-accounts/',
  
  // Payout Settings API Routes
  PayoutSettings: apiBaseURL + '/payouts/settings/',
  UpdatePayoutSettings: apiBaseURL + '/payouts/settings/update/',
  
  // Follow/Unfollow API Routes
  FollowToggle: apiBaseURL + '/auth/follow/',
  FollowStatus: apiBaseURL + '/auth/follow-status/',
  Followers: apiBaseURL + '/auth/followers/',
  Following: apiBaseURL + '/auth/following/',
  FollowCounts: apiBaseURL + '/auth/follow-counts/',
  FollowRequests: apiBaseURL + '/auth/follow-requests/',
  RespondFollowRequest: (uuid, decision) => apiBaseURL + `/auth/follow-requests/${uuid}/${decision}/`,
  ProfilePrivacy: apiBaseURL + '/auth/profile/privacy/',
  PublishingDeals: apiBaseURL + '/artists/publishing-deals/',
  PublishingDealAction: (dealId, action) => `${apiBaseURL}/artists/publishing-deals/${dealId}/${action}/`,
  PublisherSearch: apiBaseURL + '/artists/publishers/search/',
  
  // Act Follow/Unfollow API Routes
  ActFollowToggle: apiBaseURL + '/artists/act/',
  ActFollowStatus: apiBaseURL + '/artists/act/',
  ActFollowers: apiBaseURL + '/artists/act/',
  ActFollowing: apiBaseURL + '/artists/act/',
  ActFollowCounts: apiBaseURL + '/artists/act/',
  
  // Search API Routes
  GlobalSearch: apiBaseURL + '/music/search/',
  SearchSuggestions: apiBaseURL + '/music/search/suggestions/',
  SearchStats: apiBaseURL + '/music/search/stats/',
  PlatformStatistics: apiBaseURL + '/music/platform/statistics/',
  
  // Tag Browsing API Routes
  BrowseByTags: apiBaseURL + '/music/browse/tags/',
  AvailableTags: apiBaseURL + '/music/tags/available/',
  SearchTags: apiBaseURL + '/music/tags/search/',
  
  // History API Routes
  PlayHistory: apiBaseURL + '/music/history/',
  RecentlyListenedActs: apiBaseURL + '/music/history/acts/',
  RecentlyListenedAlbums: apiBaseURL + '/music/history/albums/',
  RecentlyListenedTracks: apiBaseURL + '/music/history/tracks/',
  PlayHistoryStats: apiBaseURL + '/music/history/stats/',
  
  // Rate Calculator API Routes
  CalculateStreamingRate: apiBaseURL + '/music/calculate-streaming-rate/',
  
  // Messaging API Routes
  Conversations: apiBaseURL + '/messaging/conversations/',
  ConversationDetail: apiBaseURL + '/messaging/conversations/',
  Messages: apiBaseURL + '/messaging/conversations/',
  MessageDetail: apiBaseURL + '/messaging/messages/',
  MarkMessagesRead: apiBaseURL + '/messaging/conversations/',
  CreateDirectMessage: apiBaseURL + '/messaging/direct-message/',
  CreateActMessage: apiBaseURL + '/messaging/act-message/',
  UnreadCount: apiBaseURL + '/messaging/unread-count/',
  
  // User Management API Routes
  BlockUser: apiBaseURL + '/user-management/block-user/',
  UnblockUser: apiBaseURL + '/user-management/unblock-user/',
  BlockedUsers: apiBaseURL + '/user-management/blocked-users-list/',
  ReportUser: apiBaseURL + '/user-management/report-user/',
  
  // Creator Draft Management API Routes
  CreatorDrafts: apiBaseURL + '/music/creator/drafts/',
  CreatorDraftCount: apiBaseURL + '/music/creator/draft-count/',
  CreatorAllContent: apiBaseURL + '/music/creator/content/',
  CreatorManagedCatalog: apiBaseURL + '/music/creator/managed-catalog/',
  AdminStorageStats: apiBaseURL + '/music/admin/storage-stats/',
  
  // Label Draft Management API Routes
  LabelDrafts: apiBaseURL + '/music/label/drafts/',
  
  // Curator Earnings API Routes
  CuratorEarnings: apiBaseURL + '/music/curator-earnings/',
  CuratorEarningsDetail: apiBaseURL + '/music/curator-earnings/detail/',
  CuratorEarningsStats: apiBaseURL + '/music/curator-earnings/stats/',
  CuratorLeaderboard: apiBaseURL + '/music/curator-earnings/leaderboard/',
  PlatformCurationEarnings: apiBaseURL + '/music/curator-earnings/platform/',
  TransferCurationToCredits: apiBaseURL + '/music/curator-earnings/transfer-to-credits/',
  UpdateAutoDrawCurationSetting: apiBaseURL + '/music/curator-earnings/auto-draw-setting/',
  WithdrawCuratorEarnings: apiBaseURL + '/music/curator-earnings/withdraw/',
  
  // Content Moderation API Routes
  ContentReport: apiBaseURL + '/base/content-report/',
  ContentReportList: apiBaseURL + '/base/content-reports/',
  ContentFlagList: apiBaseURL + '/base/content-flags/',
  ContentModerationLog: apiBaseURL + '/base/moderation-logs/',
  ContentTypeInfo: apiBaseURL + '/base/content-type-info/',
  ModerationDashboardStats: apiBaseURL + '/base/moderation-dashboard-stats/',
  
  // Notifications API Routes
  Notifications: apiBaseURL + '/notifications/',
  
  // Financial Reports API Routes
  ListeningExpensesReport: apiBaseURL + '/reports/listening-expenses/',
  CurationEarningsReport: apiBaseURL + '/reports/curation-earnings/',
  CreatorEarningsReport: apiBaseURL + '/reports/creator-earnings/',
  ActEarningsReport: apiBaseURL + '/reports/act-earnings/',
  ReportSummary: apiBaseURL + '/reports/summary/',
  
  // Creator Earnings Conversion API Routes
  ConvertCreatorEarningsToCredit: apiBaseURL + '/artists/creator/earnings/convert-to-credit/',
  CreatorEarningsSummary: apiBaseURL + '/artists/creator/earnings/summary/',
  
  // Label Earnings Conversion API Routes
  ConvertLabelEarningsToCredit: apiBaseURL + '/artists/label/earnings/convert-to-credit/',
  
  // Map Discovery API Routes
  DiscoverMusicByLocation: apiBaseURL + '/music/discover/location/',
  CreateLocation: apiBaseURL + '/music/locations/create/',
  SearchLocations: apiBaseURL + '/music/locations/search/',
  GetLocationMusic: (id) => apiBaseURL + `/music/locations/${id}/music/`,
  GeocodeAddress: apiBaseURL + '/music/geocode/',
  ReverseGeocode: apiBaseURL + '/music/geocode/reverse/',
  SearchPlaces: apiBaseURL + '/music/places/search/',
  GetAllContentWithLocations: apiBaseURL + '/music/all-content/',
  
  // Label Management API Routes
  PublicLabels: apiBaseURL + '/artists/labels/public/',
  LabelStatistics: apiBaseURL + '/artists/labels/statistics/',
  LabelActs: apiBaseURL + '/artists/labels/acts/',
  LabelEarnings: apiBaseURL + '/artists/labels/earnings/',
  LabelConnections: apiBaseURL + '/artists/labels/connections/',
  LabelManagedCatalog: apiBaseURL + '/artists/labels/managed-catalog/',
  LabelUserManagement: apiBaseURL + '/artists/labels/users/',
  LabelsSearch: apiBaseURL + '/artists/labels/search/',
  InviteLabel: apiBaseURL + '/artists/labels/invite/',
  InviteLabelToAlbum: (albumId) => apiBaseURL + `/music/album/${albumId}/invite-label/`,
  LabelInvitations: apiBaseURL + '/artists/labels/invitations/',
  RespondToInvitation: (id) => apiBaseURL + `/artists/labels/invitations/${id}/respond/`,
  CreateLabelInvitation: apiBaseURL + '/artists/labels/invitations/create/',
  
      // Label User Management API Routes
      LabelUserRoles: apiBaseURL + '/artists/labels/user-roles/',
      LabelUserPermissions: apiBaseURL + '/artists/labels/user-permissions/',
      LabelUserInvitations: apiBaseURL + '/artists/labels/user-invitations/',
      RespondToLabelUserInvitation: (id) => apiBaseURL + `/artists/labels/user-invitations/${id}/respond/`,
      ResendLabelUserInvitation: (id) => apiBaseURL + `/artists/labels/user-invitations/${id}/resend/`,
      GetLabelInvitationByToken: (token) => apiBaseURL + `/artists/labels/invitations/${token}/`,
      AcceptLabelInvitation: (token) => apiBaseURL + `/artists/labels/invitations/${token}/accept/`,
  
  // Publisher Management API Routes
  PublicPublishers: apiBaseURL + '/artists/publishers/public/',
  PublishersSearch: apiBaseURL + '/artists/publishers/search/',
  InvitePublisher: apiBaseURL + '/artists/publishers/invite/',
  PublisherActs: apiBaseURL + '/artists/publishers/acts/',
  MyOrganizations: apiBaseURL + '/artists/organizations/mine/',
  StartLabel: apiBaseURL + '/artists/labels/start/',
  StartPublisher: apiBaseURL + '/artists/publishers/start/',
  BecomeCreator: apiBaseURL + '/auth/become-creator/',
  BecomePodcaster: apiBaseURL + '/auth/become-podcaster/',
  MyLabelProfile: apiBaseURL + '/artists/labels/mine/profile/',
  MyPublisherProfile: apiBaseURL + '/artists/publishers/mine/profile/',
  LabelProfile: (key) => apiBaseURL + `/artists/labels/${key}/profile/`,
  PublisherProfile: (key) => apiBaseURL + `/artists/publishers/${key}/profile/`,
  LabelPlaylists: (labelId) => apiBaseURL + `/music/playlists/label/${labelId}/`,
  LabelFollow: (labelId) => apiBaseURL + `/artists/labels/${labelId}/follow/`,
  PublisherFollow: (publisherId) => apiBaseURL + `/artists/publishers/${publisherId}/follow/`,
  MessageOrganization: apiBaseURL + '/artists/organizations/message/',
  PublisherUserInvitationForMe: (id) => apiBaseURL + `/artists/publishers/user-invitations/${id}/for-me/`,
  RespondPublisherUserInvitation: (id) => apiBaseURL + `/artists/publishers/user-invitations/${id}/respond/`,
  PublisherEarnings: apiBaseURL + '/artists/publishers/earnings/',
  PublisherInvitations: apiBaseURL + '/artists/publishers/invitations/',
  RespondToPublisherInvitation: (id) => apiBaseURL + `/artists/publishers/invitations/${id}/respond/`,
  ConvertPublisherEarningsToCredit: apiBaseURL + '/artists/publishers/earnings/convert-to-credit/',
  PublisherStatistics: apiBaseURL + '/artists/publishers/statistics/',
  PublisherUserRoles: apiBaseURL + '/artists/publishers/user-roles/',
  PublisherUserPermissions: apiBaseURL + '/artists/publishers/user-permissions/',
  PublisherUserInvitations: apiBaseURL + '/artists/publishers/user-invitations/',
  RespondToPublisherUserInvitation: (id) => apiBaseURL + `/artists/publishers/user-invitations/${id}/respond/`,
  ResendPublisherUserInvitation: (id) => apiBaseURL + `/artists/publishers/user-invitations/${id}/resend/`,
  
  // Music Review API Routes
  MusicReviews: apiBaseURL + '/music/reviews/',
  MusicReviewDetail: (id) => apiBaseURL + `/music/reviews/${id}/`,
  CanReviewContent: apiBaseURL + '/music/reviews/can-review/',
  ReviewReactions: apiBaseURL + '/music/review-reactions/',
  ReviewReactionDetail: (id) => apiBaseURL + `/music/review-reactions/${id}/`,
  ReviewComments: apiBaseURL + '/music/review-comments/',
  ReviewCommentDetail: (id) => apiBaseURL + `/music/review-comments/${id}/`,
  IgnoredReviews: apiBaseURL + '/music/reviews/ignored/',
  IgnoredReviewDetail: (id) => apiBaseURL + `/music/reviews/ignored/${id}/`,
  
  // Post API Routes
  Posts: apiBaseURL + '/artists/posts/',
  PostDetail: (id) => apiBaseURL + `/artists/posts/${id}/`,
  PostFeed: apiBaseURL + '/artists/posts/feed/',
  UploadPostImage: apiBaseURL + '/artists/posts/upload-image/',
  PostLike: (postId) => apiBaseURL + `/artists/posts/${postId}/like/`,
  PostRepost: (id) => apiBaseURL + `/artists/posts/${id}/repost/`,
  PostComments: apiBaseURL + '/artists/posts/comments/',
  PostCommentDetail: (commentId) => apiBaseURL + `/artists/posts/comments/${commentId}/`,
});
